const OG_IMAGE = "https://www.panellhniesplus.gr/og-image.png"

export default function DocumentMeta({ title, description, canonical, ogImage = OG_IMAGE, ogType = "website" }) {
  return (
    <>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}

      <meta property="og:site_name" content="Πανελλήνιες+" />
      <meta property="og:locale" content="el_GR" />
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title || "Πανελλήνιες+ – Βάσεις, Μόρια & Θέματα"} />
      <meta property="og:description" content={description || ""} />
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title || "Πανελλήνιες+"} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || "Πανελλήνιες+ – Βάσεις, Μόρια & Θέματα"} />
      <meta name="twitter:description" content={description || ""} />
      <meta name="twitter:image" content={ogImage} />
    </>
  )
}